import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  Tag,
  Flex,
  Box,
  useToast,
  useDisclosure
} from '@chakra-ui/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { ContactModal } from '../ContactModal';
import { LoaderState } from '../LoaderState';

export const Directory = () => {
  const toast = useToast();
  const user = JSON.parse(localStorage.getItem('profile'));
  const [directory, setDirectory] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const getAllUserContacts = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          'https://bulk-messaging-server.herokuapp.com/contacts?userId=' + user._id
        );
        localStorage.setItem('myContacts', JSON.stringify(data));
        setDirectory(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast({
          position: 'top',
          title: 'You are offline',
          description: 'Please turn on data to use the app properly',
          status: 'warning',
          duration: null,
          isClosable: false
        });
        const offlineData = JSON.parse(localStorage.getItem('myContacts'));
        setDirectory(offlineData);
      }
    };
    getAllUserContacts();
  }, [toast, user._id]);

  return (
    <>
      {loading ? (
        <Flex pos="absolute" w="100vw" h="70vh" alignItems="center" justifyContent="center">
          <Box>
            <LoaderState />
          </Box>
        </Flex>
      ) : (
        <></>
      )}
      <Table variant="simple">
        <TableCaption>{`You have total ${directory.length} contacts`}</TableCaption>
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Mobile Number</Th>
            <Th>Tag</Th>
          </Tr>
        </Thead>
        <Tbody>
          {directory?.map((contact, index) => (
            <Tr cursor={'pointer'} key={index} onClick={onOpen}>
              <Td>{contact.name}</Td>
              <Td>{contact.phone}</Td>
              <Td>
                <Tag size="md" variant="subtle" colorScheme="teal">
                  {contact.tag}
                </Tag>
              </Td>
              <>
                <ContactModal isOpen={isOpen} onClose={onClose} contactId={contact._id} />
              </>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </>
  );
};
